var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('header',[_c('Header',{attrs:{"LogoUrl":_vm.gsInfo.web_logo},on:{"changeLang":_vm.changeLang}}),_c('NavMenu',{attrs:{"navList":_vm.navList}})],1),_c('main',[_c('router-view'),_c('back-top')],1),_c('footer',[_c('Footer',{attrs:{"gsInfo":_vm.gsInfo,"footerNavList":_vm.footerNavList}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }